<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-message-header
        icon="fuel"
        text="Je kan tanken aan pomp 2"
        :success="true"
      />
      <o-section>
        <p>
          Laat je smartphone in de wagen en neem het pistool van van de pomp om
          je tankbeurt te starten.
        </p>
        <p><strong>Ben je klaar met tanken?</strong></p>
        <p>
          Hang de pomp gewoon terug en rijd weg. Je krijgt een bevestiging eens
          de tankbeurt is afgelopen.
        </p>
        <p>
          <img src="/images/q8-commercial.png" alt="Commercial" />
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Sluiten" to="/sales/fuel/" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'

export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OMessageHeader,
    OPayButton
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss"></style>
